import { isBoolean } from "util";
import $ from 'jquery';
import J from "../../js/common.js";
import api from "../../js/apiconfig";
import niceScroll from 'jquery.nicescroll';
import common from "../../js/common.js";
// document.write("<script  src='/scripts/common.js'></script>");         
var layui = window.layui;
var cishu = 0;
export default {
    name: 'Root',
    props: {
        show: {
            type: Boolean,
            default: true,
            required: false,
            validator: function (value) {
                return isBoolean(value)
            }
        },
        showleft: {
            type: Boolean,
            default: true,
            required: false,
            validator: function (value) {
                return isBoolean(value)
            }
        }
    },
    data: function () {
        return {
            topMenu: [],
            onTopMenu: 0, //1级默认选中  默认不能为-1 否则会出现取左侧菜单时索引错误
            leftMenu: [],
            onLeftMenu: [-1, -1], //2级 ， 3级
            url: "",
            isSet: false,
            rightClass: "",
            imgBase: this.Api.imgBase,

            ShowHeadRight: false,

            //以下顶部右侧
            ShowNotice: true,
            CompanyMsg: {},
            empInfo: {
                head: "",
                empName: "未知",
                deptName: "未知"
            },
            // HeadLogo: "images/head/head-logo.png",
            CompanyLogo: "",
            ShowUpt: false,
            location: window.location,
            site: window.location.href.indexOf("/personal/") >= 0 ? "emp" : "hr",
            isDesName: false,
            HasGroup: false, //是否登录过集团管理端
            SecretText: "立即绑定", //企业微信  绑定状态的文字
            isManager:false,// 是否是管理员
            diffX:"",
            diffY:"",
            moveX:"",
            moveY:"",
            
        }
    },
    components: {

    },
    beforeCreate: function () {


        // 获取谷歌浏览器版本
        let getChromeVersion = function () {
            var arr = navigator.userAgent.split(' ');
            var chromeVersion = '';
            for (var i = 0; i < arr.length; i++) {
                if (/chrome/i.test(arr[i]))
                    chromeVersion = arr[i]
            }
            if (chromeVersion) {
                return Number(chromeVersion.split('/')[1].split('.')[0]);
            } else {
                return false;
            }
        }
        if (getChromeVersion()) {
            var version = getChromeVersion();
            console.log(version);
            if (version < 60) {
                alert('您使用的谷歌浏览器(chrome)版本过低，为了更好地体验请将浏览器升级到最新版本！');
            }
        }




        let IEVersion = function () {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
            var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
            var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
            var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
            if (isIE) {
                var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                reIE.test(userAgent);
                var fIEVersion = parseFloat(RegExp["$1"]);
                if (fIEVersion == 7) {
                    return 7;
                } else if (fIEVersion == 8) {
                    return 8;
                } else if (fIEVersion == 9) {
                    return 9;
                } else if (fIEVersion == 10) {
                    return 10;
                } else {
                    return 6; //IE版本<=7
                }
            } else if (isEdge) {
                return 'edge'; //edge
            } else if (isIE11) {
                return 11; //IE11  
            } else {
                return -1; //不是ie浏览器
            }
        }

        let ie = IEVersion();
        //alert(ie);
        if (ie > 0 && ie < 10) {

            alert('您使用的IE浏览器（或IE内核）版本过低无法正常使用请更新至IE11或使用其他浏览器（Chrome、火狐等）；若您使用的是国产浏览器请将内核模式切换为极速模式。');
        }







        layui.use(['layer'], function () {

            var layer = layui.layer;
            layer.closeAll();
        });






    },
    created: function () {










        let that = this;
        let localUrl = location.href;
        if (localUrl.indexOf(":12345") >= 0 || localUrl.indexOf("notify.ctgpayroll.com") >= 0) {
            //通知必达
        } else {
            if (this.site == "hr") {
                common.GetList(
                    "/qywx/other/isInstallTxl.jhtml", {},
                    function (res) {
                        that.empInfo = common.User.Info() || that.empInfo;
                        common.FindIsRetranslationInfo(that, res => {
                            if (res) {
                                that.isDesName = true;
                            }
                        });
                    }
                );
            } else {
                // common.GetList(
                //     "/qywx/other/isInstallTxl.empweb", {},
                //     function(res) {
                that.empInfo = common.User.Info() || that.empInfo;

                //获取用户功能权限
                // that.GetEmpPms();

                //     }
                // );
            }
        }


        // if (this.site == "hr") {


        if (this.show) {

            this.GetMenus();

        } else {
            //$(".main_right").css("width", "calc(100% - 36px);")
            //直接样式写了   不用此行JS
        }


        if (this.show) {
            this.rightClass = "main_right";
            if (this.leftMenu.length > 0) {
                this.rightClass = "main_right";
            } else {
                this.rightClass = "main_right main_right_lf_none";
            }

            if (!this.showleft) {
                this.rightClass = "main_right main_right_lf_none";
            }
        } else {
            this.rightClass = "main_right main_right_none";
        }
        // }











    },
    mounted: function () {
        let that = this;
        if(location.href.indexOf('/personal/')>=0){
            let ehr_pcUser = layui.data('ehr_pcUser');
            that.isManager = ehr_pcUser.Info.manager===0?false:true;
        }
        if (!!window.ActiveXObject || 'ActiveXObject' in window) {
            window.addEventListener('hashchange', () => {
                let currentPath = window.location.hash.slice(1)
                if (this.$route.path !== currentPath) {
                    this.$router.push(currentPath)
                }
            }, false)
        }

        // if (this.site == "hr") {

        if (this.show) {
            //A路由到B路由切换了路由的情况watch监控设置值无效，因为每个独立路由之内都是独立加载的root
            this.SetMenuOn(this.$route.query.top, this.$route.query.left);
        }
        $(document).ready(function () {
            $("#main_left").css("min-height", $(window).height() - 60).niceScroll({ autohidemode: true, cursoropacitymax: 0 });




            $(".head_menu").css("max-width", $(".head_right").width() - $(".head_person_box").width() - 30)
            //$("#main_right").niceScroll({ autohidemode: true, cursoropacitymax: 0 });
            // setTimeout(() => {
            //     $("#main_left").niceScroll();
            // }, 1);

            layui.use(['form', 'layer'], function () {
                var form = layui.form;
                // var layer = layui.layer;
                // if (window.history && window.history.pushState)
                // {
                //     //history.pushState(null, null, document.URL);
                //     window.addEventListener('popstate', function ()
                //     {

                //     }, true);
                // }
                form.render(); //更新全部
            });

            if (location.href.indexOf("/#/emp/list") >= 0) {
                that.SetAn();
            }

            if (this.site == "hr") {
                common.FindIsRetranslationInfo(that, res => {
                    if (res) {
                        WWOpenData.bindAll(document.getElementsByTagName('ww-open-data'));
                    }
                });
            }




            //判断是否有集团管理端
            try {
                //debugger;
                var user = layui.data('authenUser');
                let groupToken = user.Token;
                if (groupToken && groupToken != "" && groupToken != null) {
                    that.HasGroup = true;
                }
            } catch (error) {

            }

        });


        if (this.$route.path.indexOf("qiyewechatmonthreport") > -1) { //判断 需要先获取企业的Secret信息并绑定，企业微信打卡、审批数据才能同步到系统中
            $(".bd_link").show();
            common.Submit(api.main.getAttQywxSecrets, {}, function (res) {
                if (res.errorCode == "0") {
                    if (res.result.data.attQywxSecrets.length == 2) {
                        that.SecretText = "解除绑定"
                    }
                } else {
                    common.Msg(res.msg)
                }
            })
        }
        $('#zhi_helpsass').attr("move", 0);
//		cishu++;
//		if(cishu > 1){
//			return
//		}
//		setTimeout(()=>{
//
//          if($("#zhi_helpsass").length > 0){
//              var drag = document.getElementById('zhi_helpsass');
//              console.log(drag)
//              drag.onmousedown = function(event) {
//                  var event1 = event || dragwindow.event; //兼容IE浏览器
//                  //    鼠标点击物体那一刻相对于物体左侧边框的距离=点击时的位置相对于浏览器最左边的距离-物体左边框相对于浏览器最左边的距离
//                  var diffX = event1.clientX - drag.offsetLeft;
//                  var diffY = event1.clientY - drag.offsetTop;
//                  drag.style.cursor = "move";
//                  // if (typeof drag.setCapture !== 'undefined') {
//                  //     drag.setCapture();
//                  // }
//                  var oldX = drag.style.left;
//                  var oldY = drag.style.top;
//                  document.onmousemove = function(event) {
//                      var event2 = event || window.event;
//                      var moveX = event2.clientX - diffX;
//                      var moveY = event2.clientY - diffY;
//                      if (moveX < 0) {
//                          moveX = 0
//                      } else if (moveX > window.innerWidth - drag.offsetWidth) {
//                          moveX = window.innerWidth - drag.offsetWidth
//                      }
//                      if (moveY < 0) {
//                          moveY = 0
//                      } else if (moveY > window.innerHeight - drag.offsetHeight) {
//                          moveY = window.innerHeight - drag.offsetHeight
//                      }
//                      drag.style.left = moveX + 'px';
//
//                      drag.style.top = moveY + 'px'
//                  }
//                  document.onmouseup = function(event) {
//                      document.onmousemove = null;
//                      document.onmouseup = null;
//
//                      drag.style.cursor = "pointer";
//
//
//                      var newX = drag.style.left;
//                      var newY = drag.style.top;
//                      console.log(newX)
//                      console.log(newY)
//                      if (newX != oldX || newY != oldY) {
//                          $('#zhi_helpsass').attr("move", 1);
//                      } else {
//                          $('#zhi_helpsass').attr("move", 0);
//                      }
//
//                      //修复低版本ie bug  
//                      if (typeof drag.releaseCapture != 'undefined') {
//                          drag.releaseCapture();
//                      }
//                  }
//              }
//          }
//      },500)




        //}
    },
    watch: {
        '$route'() {
            layui.use(['layer'], function () {

                var layer = layui.layer;
                layer.closeAll();
            });

            //if (this.site == "hr") {

            if (this.show) {
                this.topMenu = [];
                this.leftMenu = [];
                this.GetMenus();
                //同一页面参数变化不会触发生命周期，此时监听route变化
                //watch route仅能监控同一路由下的路径变化 ；
                // 对路由变化作出响应...
                this.SetMenuOn(this.$route.query.top, this.$route.query.left);
                //location.href//浏览器内所有值

                //$("#main_left").css("min-height", $(document).height() - 60).niceScroll({ autohidemode: true, cursoropacitymax: 0 });
            }
            //this.$route.path //路由路径  不含#

            //this.$route.hash //含#的hash


            //this.$route.query //查询参数

            //this.$route.fullPath //path+查询参数

            if (this.show) {
                this.rightClass = "main_right";
                if (this.leftMenu.length > 0) {
                    this.rightClass = "main_right";
                } else {
                    this.rightClass = "main_right main_right_lf_none";
                }
                if (!this.showleft) {
                    this.rightClass = "main_right main_right_lf_none";
                }
            } else {
                this.rightClass = "main_right main_right_none";
            }
            //}
        }

    },
    methods: {
    	dragStart:function(e){
    		console.log(e)
    		$('#zhi_helpsass').attr("move", 1);
    		e.dataTransfer.dropEffect = "move";
    		e.dataTransfer.effectAllowed ="move";
    		this.diffX = e.clientX - e.target.offsetLeft;
    		console.log(this.diffX)
    		this.diffY = e.clientY - e.target.offsetTop;
    	},
    	dragenter:function(e){
    		$('#zhi_helpsass').attr("move", 1);
    		e.preventDefault()
    		e.dataTransfer.dropEffect = "move";
    		e.dataTransfer.effectAllowed ="move";  
    		
    	},
    	dragend:function(e){
    		console.log(e)
    		$('#zhi_helpsass').attr("move", 0);  
    		this.moveX = e.clientX - this.diffX;
    		console.log(this.moveX)
    		this.moveY = e.clientY - this.diffY;
    		console.log(e.clientX)
    		console.log(window.innerWidth)
    		console.log(e.target.offsetWidth)
    		console.log(this.moveX > (window.innerWidth - e.target.offsetWidth))
    		if(this.moveX < 0){
    			this.moveX = 0;
    		}else if(this.moveX > (window.innerWidth - e.target.offsetWidth)){
    			this.moveX = window.innerWidth - e.target.offsetWidth;
    			console.log(this.moveX)
    		}
    		if(this.moveY < 0){
    			this.moveY = 0;
    		}
    		else if(this.moveY > window.innerHeight - e.target.offsetHeight){
    			this.moveY = window.innerHeight - e.target.offsetHeight;
    		}
    		e.target.style.left=this.moveX+'px';
            e.target.style.top=this.moveY+'px';
            e.target.style.bottom='unset';
            e.target.style.right='unset';
            e.dataTransfer.dropEffect = "move"
            e.dataTransfer.effectAllowed ="move";
            
    	},
    	dragover:function(e){    		
    		$('#zhi_helpsass').attr("move", 1);
    		e.preventDefault()    		
    		e.dataTransfer.effectAllowed ="move";
    		e.dataTransfer.dropEffect = "move"
    	},
    	goHelp:function(){
    		console.log($('#zhi_helpsass'))
    		console.log($('#zhi_helpsass').attr("move"))
    		console.log(location)
    		
    		if ($('#zhi_helpsass').attr("move") == 0) {
    			if(location.host.indexOf("localhost")>=0){
      			  					window.open("http://localhost:8888/webapps/payroll/help/help.html","_blank");//本地地址
    			}else{
    				window.open("/webapps/payroll/help/help.html","_blank");  //上线需要用的地址
    			}

				
    		}
		    
    	},

        goSecret: function () { //跳转到绑定页面
            this.$router.push({ path: "/company/qiyewechatmonthreport/secret?top=17519970615296&left=18385213587456" })
        },


        GetEmpPms: function (callback) {
            let pms = common.User.RolePms() || [];
            if (pms.length == 0) {

                Promise.all([
                    common.PostPromise(
                        api.main.getAppIconSourceList, {
                        // level: 1,
                        // parentIconId: 0
                        //工作首页权限
                    }
                    ),
                    common.PostPromise(
                        api.main.workIcon, {
                        level: 1,
                        parentIconId: 0
                        //工作首页权限
                    }
                    ),
                    common.PostPromise(
                        api.main.workIcon, {
                        level: 2,
                        parentIconId: 3
                        //工作-申请模块权限
                    }
                    ),
                    common.PostPromise(
                        api.main.customIcon, {
                        // level: 2,
                        // parentIconId: 3
                        //工作-申请模块权限
                    }
                    )
                ]).then(function (ress) {
                    console.log(ress);
                    var pms = [];
                    for (let index = 0; index < ress.length; index++) {
                        var one = ress[index].result.data || ress[index].result;
                        pms.push(one);
                    }
                    common.User.RolePms(pms);

                    if (typeof callback == "function")
                        callback(pms);
                    //--------------------

                });
            } else {
                if (typeof callback == "function")
                    callback(pms);
            }
        },
        GetEmpMsg: function () {
            var _this = this;
            _this.ShowHeadRight = true;
            // /web/menu/getMenusByLevel.jhtml
            var t = {};
            if (!_this.empInfo.head || _this.empInfo.head == "") {
                _this.empInfo.head = "/static/img/icon/head.png";
                if (window.location.href.indexOf("chinasoftinc.com") >= 0) {
                    _this.empInfo.head = "/static/img/icon/zrhead.png";

                }
                if (window.location.href.indexOf("vitasoy-chn.com") >= 0) {
                    _this.empInfo.head = "/static/img/icon/vthead.png";

                }
            } else {
                if (_this.empInfo.head.indexOf("http") >= 0) {
                    _this.empInfo.head = _this.empInfo.head;
                } else {
                    _this.empInfo.head = _this.Api.imgBase + _this.empInfo.head;
                }
            }

            var t = {};
            common.Submit(
                "/web/custInfo/getFirstHtmlInfo.empweb",
                JSON.stringify(t),
                function (res) {
                    var json = res.result.data;

                    setTimeout(function () {
                        _this.CompanyMsg = json;
                        // common.User.Info.RelName.Set(_this.CompanyMsg.custName);

                        // common.User.Info.RelName.Set(_this.CompanyMsg.empName);
                        // console.log(JSON.stringify(res));
                        if (_this.CompanyMsg.infoTotal > 0) {
                            $(".notice_num").show();
                            // setInterval(function ()
                            // {

                            //     if (_this.ShowNotice)
                            //     {
                            //         _this.ShowNotice = false;
                            //         $(".notice_num").hide();
                            //     } else
                            //     {
                            //         _this.ShowNotice = true;
                            //         $(".notice_num").show();
                            //     }


                            // }, 500);
                        }
                    }, 0);
                }
            );



        },


        GetComMsg: function () {
            var _this = this;



            if (!_this.empInfo.head || _this.empInfo.head == "") {
                _this.empInfo.head = "/static/img/icon/head.png";
                if (window.location.href.indexOf("chinasoftinc.com") >= 0) {
                    _this.empInfo.head = "/static/img/icon/zrhead.png";

                }
                if (window.location.href.indexOf("vitasoy-chn.com") >= 0) {
                    _this.empInfo.head = "/static/img/icon/vthead.png";

                }
            } else {
                if (_this.empInfo.head.indexOf("http") >= 0) {
                    _this.empInfo.head = _this.empInfo.head;
                } else {
                    _this.empInfo.head = _this.Api.imgBase + _this.empInfo.head;
                }
            }





            _this.ShowHeadRight = true;
            // /web/menu/getMenusByLevel.jhtml
            var t = {};
            common.Submit(
                "/web/custInfo/getFirstHtmlInfo.jhtml",
                JSON.stringify(t),
                function (res) {
                    var json = res.result.data;

                    setTimeout(function () {
                        _this.CompanyMsg = json;
                        // common.User.Info.RelName.Set(_this.CompanyMsg.custName);

                        // common.User.Info.RelName.Set(_this.CompanyMsg.empName);
                        // console.log(JSON.stringify(res));
                        if (_this.CompanyMsg.infoTotal > 0) {
                            $(".notice_num").show();
                            // setInterval(function ()
                            // {

                            //     if (_this.ShowNotice)
                            //     {
                            //         _this.ShowNotice = false;
                            //         $(".notice_num").hide();
                            //     } else
                            //     {
                            //         _this.ShowNotice = true;
                            //         $(".notice_num").show();
                            //     }


                            // }, 500);
                        }
                    }, 0);
                }
            );
            // try
            // {
            //     common.Response.GetList('/qywx/other/getSmallWxEdition.jhtml', {}, function (res)
            //     {
            //         if (res.errorCode == "0")
            //         {

            //             $("#qylv").html("你当前的版本信息：" + res.result.data.editionName).show();

            //             console.log("446" + res.result.data.editionName);

            //         } else
            //         {
            //             //alert(res.msg);
            //             console.log("446" + JSON.stringify(res));
            //             //$("#qylv").html("你当前的版本信息：暂无");
            //         }
            //     });
            // } catch (e)
            // {

            // }

        },
        SetAn: function () {
            var url = location.href;
            var t = {}
            common.GetList(
                "/qywx/other/isInstallTxl.jhtml",
                t,
                function (res) {
                    if (res.errorCode == 0 && res.result) {
                        if (res.result.data == 1) {
                            $(".an_link").show();
                            $(document).ready(function () {
                                setTimeout(() => {
                                    $($(".main_right")[0]).css("min-height", $(window).height() - 60 - 51).css("max-height", $(window).height() - 60 - 51);
                                    $("#main_left").css("min-height", $(window).height() - 60 - 51).css("max-height", $(window).height() - 60 - 51);;
                                    $("#main_left").getNiceScroll().resize();

                                }, 10);
                            });
                        }
                    }
                });



        },
        AnTx: function () {
            let localurl = location.href;
            if (localurl.indexOf("www.ctgpayroll.com") >= 0) {
                location.href = 'https://autodiscover.ctgpayroll.com/ehr_saas/qywx/Qcode/authApp.jhtml?suiteType=2'
            } else {
                location.href = 'https://testapi.ctgpayroll.com/ehr_saas/qywx/Qcode/authApp.jhtml?suiteType=2';
            }
        },

        GoTo: function (e,index, url, index2, index3) {
            let that = this;
            // that.$MorConfirm({content:'导入成功2条',mtype:common.Constant.MORCONFIRMTYPE.MORCONFIRMERROR},()=>{
            //     console.log('前往')
            // })
            //     .then(() => {
            //       //点击确定之后的处理
            //       console.log('yes')
            //     })
            //     .catch(() => {
            //     //点击取消之后的处理
            //       console.log('no')
            //     })
            //返回管理或前往设置  无需index  直接跳转
            let sctop = $("#main_left").scrollTop()
            setTimeout(() => {
                $("#main_left").scrollTop(sctop)
            }, 500);
            if (index == -1 && index2 == -1 && index3 == -1) {
                location.href = url;
                return false;
            }

            //顶部1级
            if (!url) {
                let item = this.topMenu[index];
                if (item.url != "") {
                    let to = item.url;
                    if (item.url.includes('personal/wagelist')) {
                        that.CommonValidPwd(item.id);
                        return;
                    }

                    //含webapps  说明是薪酬功能
                    if (item.url.includes('webapps/') && (location.href.indexOf("192.168") >= 0 || location.href.indexOf("172.") >= 0 || location.href.indexOf("localhost") >= 0)) {
                        var cs = layui.data("ehr_pcStorage");
                        let thisPort = top.location.port;
                        let payPort = cs.payport;


                        var host = top.location.host; //获取当前窗口的主机名;   结果：localhost:61768

                        var payHost = host.replace(":" + thisPort, ":" + payPort);

                        location.href = "//" + payHost + to;
                        return;

                    }



                    location.href = common.Request.ParseUrl(to, [{ key: "top", value: item.id }]);
                } else {
                    this.$router.push({ path: "404", query: { top: item.id } }) // 
                    //location.href ="/#/page?top="+item.id;
                }
            } else {
                //2级
                let item2 = this.leftMenu[index2];
                let leftId = item2.id;
                if (index3 >= 0) {
                    let item3 = item2.childsList[index3];
                    leftId = item3.id;
                }
                let to = url;
                if (to.includes('personal/wagelist')) {
                    that.CommonValidPwd();
                    return;
                }
                if (to.includes('webapps/') && (location.href.indexOf("192.168") >= 0 || location.href.indexOf("172.") >= 0 || location.href.indexOf("localhost") >= 0)) {
                    // saas的二级菜单跳转智能薪酬项目(本地调试用)
                    common.GoToIntelligentCompensation(to + '?top=' + item2.parentId + '&left=' + leftId)
                } else {
                    location.href = common.Request.ParseUrl(to, [{ key: "top", value: item2.parentId }, { key: "left", value: leftId }]);
                }
            }
            //以下改变仅在同一路由下生效，切换路由后页面对象重新初始化了，则需要用生命周期监听修改赋值
            //this.onTopMenu = index;
        },

        Open: function (index2, e) {

            let that = this;
            $(document).ready(function () {
                setTimeout(() => {
                    $("#main_left").getNiceScroll().resize();

                }, 10);
            });
            let menu3 = $(e.target);
            if (!$(e.target).hasClass("menu2_item")) {
                menu3 = $(e.target).closest(".menu2_item");
            }
            //console.log(menu3);
            if (that.leftMenu[index2].open) {
                $(menu3).next("span").animate({
                    height: '0',
                    opacity: '0.1'

                }, 500, function () {
                    //$(menu3).next("span").css("display", "none");
                    that.leftMenu[index2].open = false;
                    let left2 = -1;
                    let left3 = that.onLeftMenu[1];
                    that.onLeftMenu = [left2, left3];
                });


                return;
            } else {
                for (let index = 0; index < that.leftMenu.length; index++) {
                    let item = that.leftMenu[index];
                    item.open = false;
                }
                that.leftMenu[index2].open = true;
                let left2 = index2;
                let left3 = that.onLeftMenu[1];
                this.onLeftMenu = [left2, left3];
                // $(menu3).next("span").css("height", 0);
                // $(menu3).next("span").animate({
                //     height: '200px',
                //     opacity: '1'
                // }, 1000, function() {

                // });



                // for (let index = 0; index < this.leftMenu[index2].child.length; index++)
                // {
                //     let item3 = this.leftMenu[index2].child[index];
                //     if (item3.id==this.onLeftMenu[1])
                //     {
                //         left3 = this.onLeftMenu[1]
                //     }
                // }

            }
        },
        SetMenuOn: function (topId, leftId) {
            //debugger;
            let that = this;
            //debugger;
            if (!topId) {
                topId = 0;
            }

            if (!leftId) {
                leftId = 0;
            }




            try {
                let topS = this.$route.query.topstr;
                let leftS = this.$route.query.leftstr;
                if (topId <= 0 && topS && topS.length && topS.length > 0) {
                    that.topMenu.forEach((one, index) => {
                        //debugger;
                        if (one.domStr == topS) {
                            topId = one.id;
                            this.onTopMenu = index;
                        }
                    });
                }

                if (!that.topMenu[that.onTopMenu] || !that.topMenu[that.onTopMenu].childsList) {
                    that.leftMenu = [];
                } else {
                    that.leftMenu = that.topMenu[that.onTopMenu].childsList;
                }

                if (leftId <= 0 && leftS && leftS.length && leftS.length > 0) {
                    that.leftMenu.forEach(one => {
                        if (one.childsList && one.childsList.length > 0) {

                            one.childsList.forEach(one3 => {
                                if (one3.domStr == leftS) {
                                    leftId = one3.id;
                                }
                            });
                        } else {
                            if (one.domStr == leftS) {
                                leftId = one.id;
                            }
                        }

                    });
                }
            } catch (error) {
                console.log(error);
            }


            // console.log("1:" + JSON.stringify(this.onLeftMenu));
            //顶部
            for (let index = 0; index < this.topMenu.length; index++) {
                let item = this.topMenu[index];
                if (topId > 0 && item.id == topId) {
                    this.onTopMenu = index;
                    break;
                } else if (location.href.indexOf(item.url) >= topId) {
                    this.onTopMenu = index;
                    break;
                }
            }


            if (!that.topMenu[that.onTopMenu] || !that.topMenu[that.onTopMenu].childsList) {
                that.leftMenu = [];
            } else {
                that.leftMenu = that.topMenu[that.onTopMenu].childsList;
            }
            if (this.show) {
                this.rightClass = "main_right";
                if (this.leftMenu.length > 0) {
                    this.rightClass = "main_right";
                } else {
                    this.rightClass = "main_right main_right_lf_none";
                }
                if (!this.showleft) {
                    this.rightClass = "main_right main_right_lf_none";
                }
            } else {
                this.rightClass = "main_right main_right_none";
            }

            //左侧
            for (let index = 0; index < this.leftMenu.length; index++) {
                let item = this.leftMenu[index];
                if (item.childsList && item.childsList.length > 0) {
                    for (let index3 = 0; index3 < item.childsList.length; index3++) {
                        let item3 = item.childsList[index3];
                        if (leftId > 0 && item3.id == leftId) {
                            this.onLeftMenu = [index, item3.id];
                            this.leftMenu[index].open = true;
                            break;
                        } else if (location.href.indexOf(item3.url) >= leftId) {
                            this.onLeftMenu = [index, item3.id];
                            this.leftMenu[index].open = true;
                            break;
                        }
                    }
                } else {
                    if (leftId > 0 && item.id == leftId) {
                        this.onLeftMenu = [index, "ss_" + index];
                        //this.leftMenu[index].open = true;
                        break;
                    } else if (location.href.indexOf(item.url) >= leftId) {
                        this.onLeftMenu = [index, "ss_" + index];

                        break;
                    }

                }
            }
            this.url = location.href;
            this.isSet = this.url.indexOf("/set/") >= 0 ? true : false;

            if (this.leftMenu.length > 0) {
                if (this.isSet) {
                    if (this.leftMenu[0].url.indexOf("/set/") < 0) {
                        this.leftMenu[0].isSet = false;
                    }
                } else {
                    if (this.leftMenu[0].url.indexOf("/set/") >= 0) {
                        this.leftMenu[0].isSet = true;
                    }
                }
            }

        },
        GetMenus: function () {

            //by函数接受一个成员名字符串和一个可选的次要比较函数做为参数
            //并返回一个可以用来包含该成员的对象数组进行排序的比较函数
            //当o[age] 和 p[age] 相等时，次要比较函数被用来决出高下
            var by = function (name, minor) {
                return function (o, p) {
                    var a, b;
                    if (o && p && typeof o === 'object' && typeof p === 'object') {
                        a = o[name];
                        b = p[name];
                        if (a === b) {
                            return typeof minor === 'function' ? minor(o, p) : 0;
                        }
                        if (typeof a === typeof b) {
                            return a < b ? -1 : 1;
                        }
                        return typeof a < typeof b ? -1 : 1;
                    } else {
                        throw ("error");
                    }
                }
            };
            let that = this;
            let localUrl = location.href;
            if (localUrl.indexOf(":12345") >= 0 || localUrl.indexOf("notify.ctgpayroll.com") >= 0) {
                //通知必达

                // $(document).ready(function() {
                //     $(".head_person_box").hide();
                // });


                common.GetMenuNotice(function () {
                    let menus = common.Data.Storage("sys_menus");
                    if (!menus || menus == null || menus.length <= 0) {
                        location.href = "/#/error/403?api=all";
                    } else {
                        //获取菜单  组织菜单
                        for (let index = 0; index < menus.length; index++) {
                            that.topMenu.push(menus[index]);
                        }
                        if (!that.$route.query.top) {
                            console.log(that.$route.query.top, 426);
                        } else {
                            for (let index = 0; index < that.topMenu.length; index++) {
                                let item = that.topMenu[index];
                                if (item.id == that.$route.query.top) {
                                    that.onTopMenu = index;
                                    break;
                                }
                            }
                            if (!menus[that.onTopMenu].childsList) {
                                that.leftMenu = [];
                            } else {
                                that.leftMenu = menus[that.onTopMenu].childsList;
                            }
                        }
                    }


                    //console.log(that.topMenu);
                    //console.log(that.leftMenu);
                });


            } else {
                common.GetMenu(function () {
                    let menus = common.Data.Storage("sys_menus");
                    if (!menus || menus == null || menus.length <= 0) {
                        location.href = "/#/error/403?api=all";
                    } else {
                        //emp
                        if (that.site == "emp") {
                            that.GetEmpPms(pms => {
                                // if (pms && pms != null && pms.length > 0) {
                                if (pms.length > 0)
                                    pms = pms[0];

                                for (let index = 0; index < menus.length; index++) {
                                    let obj = pms.find(f => f.iconId == menus[index].id);
                                    if (obj) {
                                        // menus[index].menu_Name = obcommon.iconName;

                                        if (obj.isShow == 1)
                                            that.topMenu.push(menus[index]);
                                    } else if (menus[index].id == 0) {
                                        that.topMenu.push(menus[index]);
                                    }
                                }

                                // menus = menus.sort(by('seq_No', by('id')));
                                //重新设置菜单名称
                                common.Data.Storage("sys_menus", menus);

                                if (!that.$route.query.top) {
                                    console.log(that.$route.query.top, 426);
                                } else {
                                    for (let index = 0; index < that.topMenu.length; index++) {
                                        let item = that.topMenu[index];
                                        if (item.id == that.$route.query.top) {
                                            that.onTopMenu = index;
                                            break;
                                        }
                                    }
                                    if (!that.topMenu[that.onTopMenu].childsList) {
                                        that.leftMenu = [];
                                    } else {
                                        that.leftMenu = that.topMenu[that.onTopMenu].childsList.filter(f => {
                                            let p = pms.find(c => c.iconId == f.id);
                                            if (p)
                                                return p.isShow == 1
                                            else
                                                return f;
                                        });

                                        that.topMenu[that.onTopMenu].childsList = that.leftMenu;
                                    }

                                    // console.log(that.leftMenu);
                                }

                            });
                            // }
                        } else { //HR
                            //获取菜单  组织菜单
                            for (let index = 0; index < menus.length; index++) {
                                that.topMenu.push(menus[index]);
                            }
                            if (!that.$route.query.top) {
                                console.log(that.$route.query.top, 426);
                            } else {
                                for (let index = 0; index < that.topMenu.length; index++) {
                                    let item = that.topMenu[index];
                                    if (item.id == that.$route.query.top) {
                                        that.onTopMenu = index;
                                        break;
                                    }
                                }
                                if (!menus[that.onTopMenu].childsList) {
                                    that.leftMenu = [];
                                } else {
                                    that.leftMenu = menus[that.onTopMenu].childsList;
                                }
                            }
                        }
                    }


                    that.topMenu = that.topMenu.sort(by('seq_No', by('id')));

                    that.leftMenu = that.leftMenu.sort(by('seq_No', by('id')));
                    //console.log(that.topMenu);
                    console.log(that.leftMenu);
                });



                if (this.site == "hr") {
                    this.GetComMsg();
                } else {
                    this.GetEmpMsg();
                }
            }






        },
        CommonValidPwd(t = 4) {
            let that = this;
            common.Submit(
                api.wageApi.isHasPassword, {},
                function (res) {

                    let mobile = common.User.Info().mobile || '13522535090';
                    if (res.msg == '此用户没有二级密码') {

                        that.$router.push({
                            path: '/personal/inputpwd',
                            query: {
                                'mobile': mobile,
                                top: t,
                                left: 111111115
                            }
                        })
                    } else {
                        console.log('2222');

                        that.$router.push({
                            path: '/personal/validpwd',
                            query: {
                                'mobile': mobile,
                                top: t,
                                left: 111111115
                            }
                        })

                    }
                    return;
                })
        },
        /**
         * 跳转到管理端
         */
        GoToManage: function () {
            let url = "/web/user/switchPlatform.empweb";
            let that = this;
            common.GetList(url, {}, res => {
                if (res.errorCode == 0) {
                    console.log(res);
                    // debugger
                    try {
                        that.SetCookie("UserToken",res.result.data.token)
                        // Rootconfig.Info.Token.Set(res.result.data.token);
                        // Rootconfig.Info.Account.Set(res.result.data.mobile);
                        // Rootconfig.SetCookie("roleType", 1);
                        // Rootconfig.SetCookie("HaveMenus", JSON.stringify(res.result.data.HaveMenus));
                        // Rootconfig.Info.ID.Set(res.result.data.empId);   
                    } catch (error) {
                    }
                    let token = res.result.data.token;
                    let rolePms = res.result.data.HaveMenus;
                    let empId = res.result.data.empId;
                    let allMenus = res.result.data.menuList;

                    let userInfo = {
                        head: res.result.data.photo,
                        empId: res.result.data.empId,
                        mobile: res.result.data.mobile,
                        empName: res.result.data.empName,
                        companyName: res.result.data.custName,
                        userName: res.result.data.empName,
                        custId: res.result.data.custId,
                        custName: res.result.data.custName,
                        deptId: res.result.data.deptId,
                        deptName: res.result.data.deptName,
                        fullDeptName: res.result.data.fullDeptName,
                        version: res.result.data.qywxEditionVerCode,
                        regTime: res.result.data.custCreateTime,
                    }
                    //设置值
                    layui.data('ehr_pcUser', {
                        key: 'Token',
                        value: token
                    });
                    layui.data('ehr_pcUser', {
                        key: 'Info',
                        value: userInfo
                    });
                    layui.data('ehr_pcUser', {
                        key: 'RolePms',
                        value: rolePms
                    });
                    layui.data('ehr_pcStorage', {
                        key: 'sys_menus',
                        value: []
                    });
                    //薪酬项目部分
                    layui.data('ehr_pcStorage', {
                        key: 'leadUserInfo',
                        value: userInfo
                    });
                    layui.data('ehr_pcStorage', {
                        key: 'apiMenus',
                        value: res.result.data.apiMenus ////薪酬部分单独功能
                    });
                    window.location.href = "/#/company/workbench/index?top=15803136905216&newid=" + Math.random();
                }else{
                    layer.close(load);
                    layer.alert(res.msg);
                }
            })

        },
         SetCookie: function(name, val) {
            var re = false;
            if (window.localStorage) {
                //h5 
                localStorage.removeItem(name);
                localStorage.setItem(name, val);
                $.cookie(name, val, { expires: 7, path: '/' });
                re = true;
            } else {
                //cookie
                $.cookie(name, val, { expires: 7, path: '/' });
                re = true;
            }
            return re;
        },
        // GetEmpMenu: function() {
        //     common.Get("/sso/menu/list/tree.ajax", JSON.stringify({ menu_Type: 1, parentId: 0 }), function(res0) {
        //         if (res0 && res0.code.length) {
        //             if (res0.code == 0 || res0.code.indexOf("成功") > -1 || res0.code.indexOf("SUCCESS") > -1) {
        //                 //获取菜单  组织菜单
        //                 let menus = res0.data;
        //                 //获取菜单  组织菜单
        //                 for (let index = 0; index < menus.length; index++) {
        //                     that.topMenu.push(menus[index]);
        //                 }
        //                 if (!that.$route.query.top) {
        //                     console.log(that.$route.query.top, 426);
        //                 } else {
        //                     for (let index = 0; index < that.topMenu.length; index++) {
        //                         let item = that.topMenu[index];
        //                         if (item.id == that.$route.query.top) {
        //                             that.onTopMenu = index;
        //                             break;
        //                         }
        //                     }
        //                     if (!menus[that.onTopMenu].childsList) {
        //                         that.leftMenu = [];
        //                     } else {
        //                         that.leftMenu = menus[that.onTopMenu].childsList;
        //                     }
        //                 }

        //             }
        //         } else {

        //         }
        //     });
        // }
    }
}